import React from 'react';
import * as styles from './styles.scss';

const Switch = ({
    className,
    ...props
}) => (
    <label className={`${styles.switch}${className ? ` ${className}` : ''}`}>
        <input type="checkbox" {...props} />
        <div className={styles.background}>
            <div className={styles.handle} />
        </div>
    </label>
);

export default Switch;
